import { motion, AnimatePresence } from 'framer-motion'

const svgVars = {
  top: {
    initial: {
      rotate: 0,
      y: 0,
      transition: {
        duration: .3,
        ease: 'easeInOut',
      }
    },
    animate: {
      rotate: 45,
      y: '8px',
      transition: {
        duration: .3,
        ease: 'easeInOut',
      }
    },
  },
  middle: {
    initial: {
      opacity: 1,
      transition: {
        duration: .3,
        ease: 'easeInOut',
      }
    },
    animate: {
      opacity: 0,
      transition: {
        duration: .3,
        ease: 'easeInOut',
      }
    },
  },
  bottom: {
    initial: {
      y: 0,
      rotate: 0,
      transition: {
        duration: .3,
        ease: 'easeInOut',
      }
    },
    animate: {
      y: '-8px',
      rotate: -45,
      transition: {
        duration: .3,
        ease: 'easeInOut',
      }
    },
  },
}

export default function MenuIcon({ flip, isOpen }: any) {
  return (
    <AnimatePresence mode='wait'>
      <svg
        className="transition-standard overflow-visible"
        width="24"
        height="18"
        viewBox="0 0 24 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <motion.path
          variants={svgVars.middle}
          initial="initial"
          animate={isOpen ? 'animate' : 'initial'}
          className="transition-standard"
          d="M1 9H23"
          stroke={flip ? "#47565A" : "#fff"}
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <motion.path
          variants={svgVars.top}
          initial="initial"
          animate={isOpen ? 'animate' : 'initial'}
          className="transition-standard"
          d="M1 1H23"
          stroke={flip ? "#47565A" : "#fff"}
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <motion.path
          variants={svgVars.bottom}
          initial="initial"
          animate={isOpen ? 'animate' : 'initial'}
          className="transition-standard"
          d="M1 17H23"
          stroke={flip ? "#47565A" : "#fff"}
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </svg>
    </AnimatePresence>
  );
}
